class Svatky {
  constructor(config) {
    this.config = config || {};
  }

  vratPolePravidelnych() {
    return (this.config.pravidelne || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  vratPoleVelikonoc() {
    return (this.config.velikonocni_pondeli || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  jeSvatek(datum = new Date()) {
    let den = datum.getDate();
    let mesic = datum.getMonth() + 1;
    let rok = datum.getFullYear();

    let denMesic = `${den}.${mesic}.`;
    let denMesicRok = `${den}.${mesic}.${rok}`;

    if (this.vratPolePravidelnych().indexOf(denMesic) > -1) {
      return true;
    }

    if (this.vratPoleVelikonoc().indexOf(denMesicRok) > -1) {
      return true;
    }

    return false;
  }
}

export { Svatky };
